export default class PaymentInfoModel {
    constructor(props) {
        this.initialCost = props.initial_cost;
        this.finalCost = props.final_cost;
        this.discountCost = props.discount_cost;
        this.allDiscounts = props.all_discounts || [];
        this.percentLimitExceeded = props.percent_limit_exceeded;
        this.bonusLimitExceeded = props.bonus_limit_exceeded;
        this.bonusMaxPercent = props.bonus_max_percent;
        this.appliedDiscounts = props.applied_discounts || 0;
        this.balances = props.balances;
        this.dividedCost = props.divided_cost;
        this.ttDiscounts = props.tt_discounts;
        this.freezeMoney = props.freeze_money;
        this.unfreezeFrom = props.unfreeze_from;
        this.paymentFormat = props.payment_format;
        this.paymentFormats = props.payment_formats || [];
        this.payparts = props.payparts;
        this.paypartsOptions = props.payparts_options || {};
        this.paypartsFullCost = props.payparts_full_cost;
        this.paymentsNumber = props.payments_number;
        this.paymentSystem = props.payment_system;
        this.gatewayId = props.gateway_id;
    }

    /**
     * @param {PaymentInfoModel} paymentInfo
     * @return {boolean}
     */
    equals(paymentInfo) {
        if (!paymentInfo) {
            return false;
        }

        return JSON.stringify(this) === JSON.stringify(paymentInfo);
    }

    /**
     * @param {PaymentInfoModel} paymentInfo
     * @return {boolean}
     */
    equalBalances(paymentInfo) {
        if (!paymentInfo) {
            return false;
        }

        return JSON.stringify(this.balances) === JSON.stringify(paymentInfo.balances);
    }

    /**
     * @param {PaymentInfoModel} paymentInfo
     * @return {boolean}
     */
    equalPaymentFormats(paymentInfo) {
        if (!paymentInfo) {
            return false;
        }

        const fields = ['paymentFormat', 'paymentFormats', 'paypartsOptions', 'paymentsNumber'];
        const obj1 = this.getWith(fields);
        const obj2 = paymentInfo.getWith(fields);
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }

    /**
     * @param {PaymentInfoModel} paymentInfo
     * @return {boolean}
     */
    equalPaymentFormatList(paymentInfo) {
        if (!paymentInfo) {
            return false;
        }

        const fields = ['paymentFormats'];
        const obj1 = this.getWith(fields);
        const obj2 = paymentInfo.getWith(fields);
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }

    getWith(fields = []) {
        return fields.reduce((acc, field) => {
            if (this.hasOwnProperty(field)) {
                acc[field] = this[field];
            }

            return acc;
        }, {});
    }

    getCouponDiscount() {
        return this.allDiscounts.find((discount) => discount.type === 'coupon');
    }
}